<template>
    <div class="feed-list" v-if="insights">
        <header class="feed-list-header">
            <!--<p>{{ unreadInsightsNumber }} unread notifications</p>-->
            <div class="feed-controls">
                <!--<button class="button button-primary"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z" /></svg></button>-->
                <div id="myComponent" style="width: 200px;">
                    <select v-model="selectedProduct" v-show="isShow" class="dropdown">
                        <option class="productList">All Products</option>
                        <option class="productList" v-for="product in uniqueProducts(insights)" :key="product">
                            {{product}}
                        </option>
                    </select>
                </div>
            </div>
        </header>
        <feed-item v-for="insight in filteredInsights(insights)" :key="insight.name" :content="insight" />
    </div>
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex'
    import FeedItem from './FeedItem.vue'
  

    export default {
        name: 'FeedList',
        data() {
            return {
                selectedProduct: 'All Products',
                isShow: true
            }
        },
        components: {
            'feed-item': FeedItem
        },
        computed: {
            ...mapGetters(['insights'])//, 'unreadInsightsNumber'])
        },
        methods: {
            ...mapMutations(['SELECT_CONTENT']),
            selectContent() {
                let content = this.content

                this.SELECT_CONTENT(content)
            },
            uniqueProducts(insights) {
                let products = [...new Set(insights.map(insight => insight.product))]

                if (products.length > 1) {
                    this.isShow = true;
                } else {
                    this.isShow = false;
                }

                return products
            },
            filteredInsights(insights) {
                if (this.selectedProduct == 'All Products') {
                    return insights
                }
                else {
                    return insights.filter(insight => insight.product == this.selectedProduct)
                }
                
            }
            
        }
    }

</script>

<style lang="scss" scoped>
    @use 'sass:math';
    @import '../styles/base';
    @import '../../node_modules/hd-styles/modules/mixins';

    p {
        font-weight: 600;
        margin: 0;
    }

    .productList{
        color: black;
    }

    .dropdown {
        border-color: $grey-dark;
        color: black;
    }

    .dropdown:hover {
        border-color: $blue-mid;
        color: black;
    }

    .feed-list-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: $spacing-unit;
    }

    .feed-controls {
        display: flex;
        gap: math.div($spacing-unit, 2);
    }
</style>
